import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { User_reducer } from "./User";
import { Report_reducer } from "./Reports";
import { Dashboard_reducer } from "./Dashboard";
import { CourtCase_reducer } from "./CourtCase";
import { Civil_reducer } from "./Civil";
import BD_reducer from "./BD/reducer";
import Accounts_reducer from "./Accounts/reducer";
import HR_reducer from "./HR/reducer";
import Procurement_reducer from "./Procurement/reducer";
import Sales_reducer from "./Sales/reducer";
import CRM_reducer from "./CRM/reducer";
import Admin_reducer from "./Admin/reducer";
import QC_reducer from "./QC/reducer";
import Compliance_reducer from "./Compliance/reducer";
import Marketing_reducer from "./Marketing/reducer";
import AssestsAccount_reducer from "./AssestsAccounts/reducer";
import Audit_reducer from "./Audit/reducer";

const All_reducers = combineReducers({
  user: User_reducer,
  reports: Report_reducer,
  dashboard: Dashboard_reducer,
  courtCase: CourtCase_reducer,
  civil: Civil_reducer,
  bd: BD_reducer,
  accounts: Accounts_reducer,
  hr: HR_reducer,
  admin: Admin_reducer,
  procurement: Procurement_reducer,
  sales: Sales_reducer,
  crm: CRM_reducer,
  qc: QC_reducer,
  accounts_assests: AssestsAccount_reducer,
  compliance: Compliance_reducer,
  marketing: Marketing_reducer,
  audit: Audit_reducer
});

const store = createStore(
  All_reducers,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : (f) => f
  )
);

export default store;
